module.exports = __webpack_public_path__ + "c27ca8290f5c9e6d3bda4537e23575e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/japanese-restaurant.png
// module id = 562
// module chunks = 0